import React from 'react';
import { Card } from '@/components/ui/card';
import { 
  FolderOpen, 
  Zap, 
  CheckCircle2 
} from 'lucide-react';

export function SummaryCards({ projects, activeProjects, avgCompletion }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card className="p-6 border border-gray-200" data-testid="total-projects-card">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Total de Projetos</p>
            <p className="text-3xl font-semibold text-gray-900 mt-2">{projects.length}</p>
          </div>
          <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
            <FolderOpen className="w-6 h-6 text-emerald-800" />
          </div>
        </div>
      </Card>

      <Card className="p-6 border border-gray-200" data-testid="active-projects-card">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Projetos Ativos</p>
            <p className="text-3xl font-semibold text-gray-900 mt-2">{activeProjects.length}</p>
          </div>
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <Zap className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </Card>

      <Card className="p-6 border border-gray-200" data-testid="completion-card">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Conclusão Média</p>
            <p className="text-3xl font-semibold text-gray-900 mt-2">{avgCompletion.toFixed(1)}%</p>
          </div>
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
            <CheckCircle2 className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </Card>
    </div>
  );
}

export default SummaryCards;
